import React from 'react'
import './AppStoreDownloadItem.css'

const AppStoreDownloadItem = ({
  appName,
  description,
  buttonText,
  logoSrc,
  url,
}) => {
  return (
    <div className="app-store-download-item">
      <img src={logoSrc} alt={`${appName} Logo`} className="app-logo" />
      <div className="app-info">
        <h3 className="app-name">{appName}</h3>
        <p className="app-description">{description}</p>
        <a href={url} target="_blank" rel="noopener noreferrer">
          <button className="app-download-button">{buttonText}</button>
        </a>
        <p className="app-note">Free</p>
      </div>
    </div>
  )
}

export default AppStoreDownloadItem
